export default __webpack_public_path__ + "static/media/1719.cd54e5ec.png";